import { preciseMultiply } from '@slot-nx/core'
export enum BetOptionType {
  MainGame = 0,
  FreeGame = 1,
  ThreeCombo = 2,
}
const BetOptionMultiMap = new Map<BetOptionType, number>([
  [BetOptionType.MainGame, 1],
  [BetOptionType.FreeGame, 60],
  [BetOptionType.ThreeCombo, 200],
])

export const getPayStake = (stake: number, betOptionType: BetOptionType): number => {
  const betOptionMulti = BetOptionMultiMap.get(betOptionType) || 1
  return preciseMultiply(stake, betOptionMulti)
}
